import Vue from "vue";
import Vuex from "vuex";
import service from "../service";
import constant from "src/constant";
import constants from "src/app/customer/constant";
import modules from "./modules/index";
import md5 from "js-md5"; //引入
import { getLostMessages } from "src/app/customer/utils/message";
import {
  getDeviceInfo,
  getDeviceSystem,
  getBrower,
  updateRecharge
} from "../utils";
import utils from "src/utils";
import socket from "src/utils/socket";
import { Message, MessageBox } from "element-ui";
// import proto from "../../../proto";
import VuexPersistence from "vuex-persist";
import store from "../store";
import cantants from "../constant";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import MobileDetect from "mobile-detect";
import { isApp, backPage } from "../utils/bridge";
import { closeWindows } from "../utils/win";
import canstant from "@/app/customer/constant";

(async () => {
  console.log("MobileDetect", MobileDetect);
  var device_type = navigator.userAgent; //获取userAgent信息
  var md = new MobileDetect(device_type); //初始化mobile-detect
  console.log("12", md.ua);
  console.log(md5);
  // We recommend to call `load` at application startup.
  const fp = await FingerprintJS.load();
  // The FingerprintJS agent is ready.
  // Get a visitor identifier when you'd like to.
  let result = await fp.get();
  if (md && md.ua) {
    result = result.visitorId + md.ua;
  } else {
    result = result.visitorId;
  }
  // This is the visitor identifier:
  console.log("加密前", result);
  const visitorId = md5(result);
  console.log("visitorId", visitorId);
  store.commit("setState", {
    deviceCode: visitorId,
    deviceInfo: md
  });
})();

Vue.use(Vuex);

const state = {
  more: false, //更多菜单
  isshowsend: false, //是否显示发送按钮
  domain: {}, //域名配置
  isSend: false, //是否发送
  isMsgUpload: false, //是否在上传中
  isCommon: false, //是否含有欢迎语
  socketstatus: false,
  isclickimg: false,
  // 聊天历史分页参数
  messagePageNumber: 1,
  beginTime: 0, //历史记录参数
  hasHistory: false, //有无历史记录
  hasHistoryLoad: false, //有无历史记录动画
  triggerId: 0, //会话类型
  isload: true, //loading动画显示
  channelId: 0, // 会话ID
  serverId: 0, // 客服 id
  serverName: "贝贝", // 客服名称
  serverImage: "", // 客服头像
  visibleEvaluate: false, // 是否显示评价弹窗
  enterScene: 0, //会话场景
  hideHeader: false,
  deviceCode: "",
  deviceInfo: {}, //浏览器 版本信息
  token: "",
  userId: "", // 客户ID
  userName: "", // 客户名称
  skillId: "", // 瓜瓜技能组
  type: 2, // 用户类型    1：会员 2：游客
  chatType: 0, // 问题类型 默认为游客问题
  blackFlag: 0, // 是否拉黑 1:拉黑 0：正常 2:拉黑七天
  queueNumber: "", //排队人数
  questionTypes: [], //技能组
  isback: false,
  height: 0, //pc端高度

  urlDomain: "", // 其他页面传过来的域名
  //评价配置信息
  evaluateConfig: {
    evaluateStarName: "", //评价星级库名称 "态度极差&态度差&一般&满意&非常满意."
    evaluateTag: "", //评价标签库id "542,543,544,545"
    evaluateTagName: "", //评价标签库名称 "服务周到&回答及时&业务熟练&不礼貌"
    solveFlag: 1 //开启是否解决问题 0否 1是
  },
  isnewChannel: false,
  gameListResult: false,
  rechargeListResult: false,
  //评论结果查询
  evaluateResult: {
    cusEvaluateState: null, //用户是否已评价 true/false
    cusSolveState: null, //客户评价状态(已解决/未解决) true/false
    evaluateLevel: null, //评价星级
    evaluateStarName: null, //评价星级内容
    evaluateFlag: null, //评价标签
    evaluateContent: null, //评价内容
    evaluateRemark: null, //评价内容
    evaluateTagName: null //评价标签内容
  },
  questionText: "", // H5选择问题的名称
  customerInfo: undefined,
  isConversationEnd: false,
  isShowEvaluatePage: false, // 是否显示评价
  isConversation: false, // 是否显示聊天输入框
  isQueue: false, // 是否排队中
  isUploadImg: false, // pc端是否展示上传界面的标识,
  orderImgUrls: "", // 创建会话上传的图片
  isBeforeConnect: true, //连接前的状态
  invitationEvaluateFlag: false, //是否邀请评价 默认为false
  DoMain: null,
  exclusiveDomain: "",
  socketStatus: undefined, // socket 连接状态
  socketConnectSuccess: false, //鉴权是否成功
  serverAvatar: require("src/assets/imgs/server-avatar.jpg"),
  isShowHistoryBtn: true,
  alreadyLogin: false,
  isPerson: false, //是否选中的人工客服,
  isJump: false, //是否点击跳过
  queueTimer: null,
  serverAlias: "", //客服昵称
  isEntering: false, //客服是否正在输入
  // 时间容器
  timeObj: null,
  timeout: 10 * 1000,
  // 主题
  themeArray: [
    "red",
    "orange",
    "yellow",
    "green",
    "cyan",
    "blue",
    "violet",
    "gray",
    "pink",
    "black",
    "brown"
  ],
  mainColor: sessionStorage.getItem("mainColor") || "yellow",
  isSendFlag: false, //是否为客服发送消息
  rechargeCode: "", //充值码
  dialogVisible: false, //回到新会话
  showNewChannelDialog: false,
  dialogtime: false, //排队超时
  channeltime: false, //会话超时
  urlData: {}, //是否显示弹窗
  isreenter: 0, //是否是从c端跳转
  orderNum: null, //订单号,
  skillType: 0, //技能组标记1代表 充值订单，2 代表提现订单，3 代表 注单订单默认为0
  listStatus: false, //订单弹框
  activeName: "1", //订单默认选中
  sendEnterFlag: false, //是否正在输入
  isshowBtn: true,
  lastMsgId: "", //选择订单的msgId
  isShowNotice: false,
  NoticeMessage: {},
  ismarqueue: false,
  SysNotice: false,
  scenesId: 0,
  isSpecialScenes: false, // 是否为特殊场景,
  content: "",
  isSeoView: false
};

const vuexPersist = new VuexPersistence({
  strictMode: true,
  storage: sessionStorage, // 存入sessionStorage
  reducer: state => state
});

export default new Vuex.Store({
  modules,
  state,
  getters: {
    messages(state) {
      let messages = _.get(state, `chat.messageMap[${state.userId}]`, []);
      // console.log(messages, "messages changed", messages.length);
      //
      return messages.sort((prev, next) => {
        return prev.chatTime - next.chatTime;
      });
    },
    currCustomerId(state) {
      return _.get(state, "userId", "");
    },
    isLogin(state) {
      return state.customerInfo !== undefined;
    },
    target(state) {
      return {
        userId: state.serverId,
        userName: state.serverName,
        channelId: state.channelId,
        serverAlias: state.serverAlias
      };
    },
    self(state) {
      return {
        userId: state.userId,
        userName: state.userName
      };
    }
  },
  actions: {
    updataMeeage({ commit }, { messages }) {
      commit("setState", {
        messages
      });
    },
    socketEvent({ commit }, { socketStatus }) {
      commit("setState", {
        socketStatus
      });
    },
    async initChannel(
      { commit, state, dispatch },
      { orderImgUrls, queryOrderType, router }
    ) {
      if (state.customerInfo.blackFlag === 1 || state.blackFlag === 1) {
        // 获取自动回复消息内容
        const { data: autoReplyMessage } = await service.getAutoReplyMessage({
          type: 4
        });
        const message = {
          type: constant.MESSAGE_TYPE.MT_TEXT,
          content: autoReplyMessage,
          sendFlag: true,
          chatTime: utils.getTime()
        };
        // 添加消息到聊天界面
        store.commit(
          "chat/addMessage",
          { customerId: store.state.userId, message },
          { root: true }
        );
        return autoReplyMessage;
      }
      commit("setState", {
        isShowEvaluatePage: false
      });
      const { chatType, type, isSpecialScenes } = state;
      const userId = state.customerInfo.userId;
      const userName = state.customerInfo.userName;
      const params = {
        chatType,
        type,
        userId,
        userName
      };

      if (isSpecialScenes) {
        params["triggerId"] = chatType;
        params["enterScene"] = chatType;
      }

      await socket.initSocket();
      if (!state.isback) {
        // 上传设备信息
        await dispatch("collectDeviceInfo", {
          ...getDeviceInfo(),
          userId,
          userName,
          enclosure: orderImgUrls,
          questionType: state.chatType,
          enterPage: Number(state.urlData.enterPage)
          // userVersion: cantants.userVersion
        }).catch(async () => {
          await dispatch("collectDeviceInfo", {
            ...getDeviceInfo(),
            userId,
            userName,
            enclosure: orderImgUrls,
            questionType: state.chatType,
            enterPage: Number(state.urlData.enterPage)
            // userVersion: cantants.userVersion
          }).catch(async () => {
            await dispatch("collectDeviceInfo", {
              ...getDeviceInfo(),
              userId,
              userName,
              enclosure: orderImgUrls,
              questionType: state.chatType,
              enterPage: Number(state.urlData.enterPage)
              // userVersion: cantants.userVersion
            }).catch(async () => {
              window.reload();
            });
          });
        });
        store.commit("setState", {
          isback: false
        });
      }

      params.orderImgUrls = orderImgUrls;
      params.platformOrder = state.orderNum;

      if (state.enterScene == constants.WakeUpScene.Recharge) {
        params.rechargeCode = state.rechargeCode;
      } else if (
        state.enterScene == constants.WakeUpScene.NotReceived ||
        state.enterScene == constants.WakeUpScene.Reflect ||
        state.enterScene == constants.WakeUpScene.Game
      ) {
        params.platformOrderType = state.enterScene - 1;
      } else {
        params.platformOrderType = queryOrderType ? queryOrderType : "";
      }
      store.commit("setState", { isload: true });
      let num = 0;
      let timer = setInterval(async () => {
        num++;
        if (state.socketConnectSuccess) {
          clearInterval(timer);
          let result = await dispatch("createChannel", params);
          if (result) {
            let data = service.getquerySessionValid({
              userId: store.state.userId,
              enterScene: parseInt(store.state.enterScene)
            });
            const constat = canstant;
            data.then(res => {
              //返回1（有效会话）
              //排队页唤醒：进入会话页
              //chat页唤醒：进入会话页（多段确认）
              if (res.data.invalidFlag == constat.invalidFlag.Effective) {
                store.commit("setState", {
                  // messagePageNumber: 1
                  beginTime: 0
                });

                store.dispatch("getMessages", { userId: store.state.userId });
                store.commit("setState", {
                  isConversationEnd: false,
                  isConversation: true,
                  isShowEvaluatePage: false,
                  // isQueue: false,
                  isShowHistoryBtn: false,
                  hasHistory: false,
                  userId: res.data.userId,
                  channelId: res.data.channelId
                });
                if (store.state.isQueue) {
                  store.dispatch("initChannel", {
                    orderImgUrls: ""
                  });
                  store.commit("setState", {
                    isQueue: false
                  });
                }
                if (store.state.enterScene == constat.WakeUpScene.Recharge) {
                  updateRecharge();
                }
                return false;
              }
              //返回2（无效会话，分排队页面和chat页面进入）
              //排队页唤醒：排队超时
              //chat页唤醒：chat结束页
              if (
                res.data.invalidFlag == constat.invalidFlag.invalid &&
                !store.state.isQueue
              ) {
                // store.dispatch("getMessages", { userId: store.state.userId });
                store.commit("setState", {
                  isConversationEnd: true,
                  isConversation: false,
                  isShowEvaluatePage: true,
                  isQueue: false,
                  isShowHistoryBtn: false,
                  hasHistory: false,
                  beginTime: 0
                });
                store.dispatch("getMessages", { userId: store.state.userId });
                return false;
              } else if (
                res.data.invalidFlag == constat.invalidFlag.invalid &&
                store.state.isQueue
              ) {
                store.commit("setState", {
                  isConversation: false,
                  dialogtime: true,
                  dialogVisible: false,
                  channeltime: false
                });
              }
              //返回3排队中,排队页面唤醒不做处理，继续返回排队页面；chat页面唤醒不会返回3，多端可能出(chat页隐藏，sdk到了排队)，
              //后台村这个用户就是排队，此时会返回3，你们需要多端和技术确认是否有，有则进入排队（待确认token）;
            });
            if (router) {
              router.push("/conversation");
            }
          }
        } else {
          // 15s后弹框
          if (num == 30) {
            clearInterval(timer);
            store.commit("setState", { isload: false });
            MessageBox.confirm("登录异常，请重新进入客服系统咨询", "提示", {
              customClass: `tourist-before-login ${state.mainColor} finishChannel`,
              confirmButtonClass: "confirmBtn",
              cancelButtonClass: "cancelBtn",
              confirmButtonText: "好的",
              type: "warning",
              showCancelButton: false,
              center: true,
              showClose: false
            })
              .then(() => {
                closeWindows();
              })
              .catch(() => {});
          }
        }
      }, 500);
    },
    // 创建会话
    async createChannel({ commit, state, dispatch }, params) {
      let flag;
      // commit("clearAllMessages");
      await service
        .createChannel(params)
        .then(matchResult => {
          if (matchResult) {
            if (matchResult.data) {
              console.log("创建会话成功");
              commit("setState", {
                isload: false,
                serverAvatar: matchResult.data.serverImage,
                // serverAlias: matchResult.data.serverAlias,
                isBeforeConnect: false
                // messagePageNumber: 1
              });
              let messages = matchResult.data.chatCusServerDetailList;
              if (Array.isArray(messages) && messages.length > 0) {
                commit("setState", {
                  isShowHistoryBtn: true,
                  hasHistory: true,
                  beginTime: messages[0].createTime
                });
                messages.forEach(message => {
                  if (message.commandType == 1) {
                    message.conversationTip = -3;
                  }
                  commit(
                    "chat/addMessage",
                    { customerId: state.userId, message },
                    { root: true }
                  );
                });
              }

              // 创建会话成功
              dispatch("matchSuccess", matchResult.data);
              if (
                state.chat.messageMap[state.userId] &&
                state.chat.messageMap[state.userId].length == 0
              ) {
                commit("setState", {
                  beginTime: 0
                });
                // await dispatch("getMessages");
              }
              // }
            } else if (matchResult.status === 200) {
              // 排队中
              commit("setState", {
                isQueue: true,
                isBeforeConnect: false,
                isload: false
              });
              commit("clearAllMessages");
              dispatch(
                "chat/addSysMessage",
                { content: matchResult.message },
                {
                  root: true
                }
              );
              dispatch("addQueueTipText");
            } else if (matchResult.code === "1004") {
              // 设置被拉黑
              store.commit("setState", {
                isUploadImg: false,
                isBeforeConnect: false,
                isPerson: true,
                chatType: 0,
                isload: false,
                blackFlag: 1,
                isConversation: false
              });
              service
                .getAutoReplyMessage({
                  type: 4
                })
                .then(res => {
                  const autoReplyMessage = res.data;
                  const message = {
                    type: constant.MESSAGE_TYPE.MT_TEXT,
                    content: autoReplyMessage,
                    sendFlag: true,
                    chatTime: utils.getTime()
                  };
                  // 添加消息到聊天界面
                  store.commit(
                    "chat/addMessage",
                    { customerId: store.state.userId, message },
                    { root: true }
                  );
                  flag = true;
                });
            }
            commit("setState", {
              isnewChannel: false
            });
            flag = true;
          } else {
            store.commit("setState", { isload: false });
            flag = false;
          }
        })
        .catch(err => {
          this.loading = false;
          if (err.response.status == 510) {
            store.commit("setState", {
              triggerId: cantants.WakeUpScene.ordinary,
              enterScene: cantants.WakeUpScene.ordinary
            });
            dispatch("queryCusSkill");
            commit("setState", {
              isload: false
            });
            flag = false;
          }
        });
      return flag;
    },
    // 技能组
    async queryCusSkill() {
      // const userId = state.customerInfo.userId;
      const { data: questionTypes } = await service.queryCusSkill({
        userId: state.customerInfo.userId
      });
      store.commit("setState", { questionTypes });
    },
    //获取历史记录
    async getMessages({ state, commit }) {
      let isfirst = 0;

      commit("setState", { hasHistoryLoad: true });

      console.log(state.beginTime);
      if (state.beginTime == "-1") {
        commit("setState", {
          isShowHistoryBtn: false,
          hasHistory: false,
          hasHistoryLoad: false
        });
        return false;
      }
      await service
        .getHistoryMessage({
          userId: state.userId,
          beginTime: state.beginTime,
          messageType: 0
        })
        .then(res => {
          if (res && res.code == 200) {
            if (state.beginTime == 0) {
              // commit("clearAllMessages");
              isfirst = 1;
            } else {
              isfirst = 0;
            }
            let messages = res.data.chatCusServerDetailList;

            if (!Array.isArray(messages)) {
              commit("setState", {
                isShowHistoryBtn: false,
                hasHistory: false,
                beginTime: "-1"
              });
            } else if (Array.isArray(messages) && messages.length > 0) {
              commit("setState", {
                isShowHistoryBtn: true,
                hasHistory: true,
                beginTime: res.data.beginTime
              });
            }

            addMessageToChat(messages, commit);
            fixMessageDom(messages, isfirst);
          }
          commit("setState", { hasHistoryLoad: false });
        })
        .catch(() => {
          commit("setState", { hasHistoryLoad: false });
        });

      function fixMessageDom(messages, isfirst) {
        setTimeout(() => {
          if (document.querySelector(`#customer-pc-msg-10`)) {
            if (isfirst == 1) {
              let offsetTop = document.querySelector(
                `#customer-pc-msg-${messages.length - 4}`
              ).offsetTop;
              if (utils.isMobile()) {
                const headerEl = document.querySelector(`#header`);
                let height = headerEl && headerEl.clientHeight;
                document.querySelector(`#messageBox`).scrollTop =
                  offsetTop - height;
                scrollBy(0, offsetTop - height);
                document.body.scrollTop = offsetTop - height;
                // document.querySelector(`#customer-pc-msg-${messages.length}`).scrollIntoView(true);
              } else {
                document.querySelector(`#messageBox`).scrollTop =
                  offsetTop - 15;
              }
            } else {
              let offsetTop = document.querySelector(
                `#customer-pc-msg-${messages.length}`
              ).offsetTop;
              if (utils.isMobile()) {
                const headerEl = document.querySelector(`#header`);

                let height = headerEl && headerEl.clientHeight;
                document.querySelector(`#messageBox`).scrollTop =
                  offsetTop - height;
                scrollBy(0, offsetTop - height);
                document.body.scrollTop = offsetTop - height;
                // document.querySelector(`#customer-pc-msg-${messages.length}`).scrollIntoView(true);
              } else {
                document.querySelector(`#messageBox`).scrollTop =
                  offsetTop - 15;
              }
            }
          }
        }, 100);
      }

      function addMessageToChat(messages, commit) {
        messages.forEach(message => {
          // if (message.commandType == 1) {
          //   message.conversationTip = -3;
          // }
          if (message.payDetail && message.payDetail != "{}") {
            message.payDetail = JSON.parse(message.payDetail);
          } else if (message.orderDetail && message.orderDetail != "{}") {
            message.orderDetail = JSON.parse(message.orderDetail);
          }
          commit(
            "chat/addMessage",
            { customerId: state.userId, message },
            { root: true }
          );
        });
      }
    },
    //获取排队人数
    async getCusQueueNumber({ state }) {
      const { data } = await service.queryCusQueue({
        userId: state.userId,
        chatType: state.chatType
      });
      return data;
    },
    async matchSuccess({ commit }, matchResult) {
      commit("setState", {
        ...matchResult,
        isQueue: false,
        isConversation: true
      });
    },
    /**
     * 每次接收到新的websocket信息，需要检测中间是否丢失消息
     * 如果有丢失，把丢失的sort集合给后台，获取到这些丢下消息
     * @param _
     * @param message
     */
    async acceptMessage(_, message) {
      const { getters, state, commit } = _;
      const { messages } = getters || {};
      const { channelId } = state;

      if (messages && messages.length) {
        const curChannelMessages = messages.filter(
          item => item.channelId === channelId
        );

        // console.log(
        //   curChannelMessages.map(item => item.sort),
        //   curChannelMessages.map(item => item.channelId)
        // );

        const { lostSorts } = getLostMessages(curChannelMessages);
        console.log(lostSorts, "lostSorts");

        if (lostSorts.length) {
          // 获取自动回复消息内容
          const { data } = await service.getLostHistoryMessages({
            sort: lostSorts,
            channelId: channelId,
            userId: state.userId
          });
          const { chatCusServerFieldDetailList = [] } = data;

          console.log(lostSorts, data);

          chatCusServerFieldDetailList.forEach(item => {
            commit(
              "chat/addMessage",
              { customerId: state.userId, message: item },
              { root: true }
            );
          });
        }
      }
      console.log("acceptMessage from chat in root", message);
    },
    async acceptCommand({ commit, dispatch, state }, message) {
      console.log("acceptCommand", message);

      store.commit("setState", {
        isSendFlag: false
      });
      switch (message.commandType) {
        // 匹配成功
        case constant.COMMAND_TYPE.CT_MATCH: {
          clearInterval(state.queueTimer);
          const {
            serverId,
            channelId,
            serverName,
            serverImage,
            serverAlias
          } = message;
          commit("setState", {
            serverAvatar: message.serverImage,
            isQueue: false,
            beginTime: 0,
            isshowBtn: true
          });
          //清空除了匹配语以外的所有信息
          commit("chat/setState", {
            messageMap: {
              [state.userId]: state.chat.messageMap[state.userId].filter(
                s =>
                  s.type === constant.MESSAGE_TYPE.MT_COMMAND &&
                  s.commandType === constant.COMMAND_TYPE.CT_MATCH
              )
            }
          });
          // 匹配成功
          dispatch("matchSuccess", {
            serverId,
            channelId,
            serverName,
            serverImage,
            serverAlias,
            isQueue: false
          });
          if (state.enterScene == cantants.WakeUpScene.Recharge) {
            await updateRecharge();
          }
          // 是否commit同上边可以合并一起 待优化
          commit("setState", {
            isShowEvaluatePage: false,
            hasHistory: true,
            isCommon: true
          });
          const messageBox = document.querySelector("#messageBox");
          if (messageBox) {
            window.messageBox = messageBox;
            setTimeout(() => {
              messageBox.scrollTop = messageBox.scrollHeight + 350;
              messageBox.scrollIntoView(messageBox.scrollHeight);
              scrollBy(0, messageBox.scrollHeight);
              document.body.scrollTop = messageBox.scrollHeight;
            }, 500);
          }
          // await dispatch("getHistory"); //获取聊天记录但不显示
          // commit("clearAllMessages");
          // await dispatch("getMessages");
          break;
        }
        //结束会话
        case constant.COMMAND_TYPE.CT_CLOSEMSG:
        case constant.COMMAND_TYPE.CT_CHANNEL_TIMEOUT:
        case constant.COMMAND_TYPE.CT_DISCONNECT:
          console.log("结束会话");
          dispatch("closeChannel");
          break;
        // 邀请评价
        case constant.COMMAND_TYPE.CT_INVITE_REVIEW:
          commit("setState", {
            invitationEvaluateFlag: true,
            visibleEvaluate: true
          });
          break;
        // 首次响应超时报警
        case constant.COMMAND_TYPE.CT_FIRST_RESPONSE_TIMEOUT:
          // commit("setState", {
          //   isConversationEnd: true,
          //   isConversation: false,
          //   isShowEvaluatePage: true
          // });
          break;
        // // 会话转接
        case constant.COMMAND_TYPE.CT_TRANSFER:
        case constant.COMMAND_TYPE.CT_SNATCH_CONVERSATION_IN:
          commit("setState", {
            isConversationEnd: false,
            isConversation: true,
            isShowEvaluatePage: false,
            channelId: message.channelId,
            serverId: message.serverId,
            serverName: message.serverName,
            serverImage: message.serverImage,
            serverAvatar: message.serverImage,
            serverAlias: message.serverAlias,
            isBeforeConnect: false
          });

          service.createChannel({
            chatType: state.chatType,
            orderImgUrls: state.orderImgUrls,
            type: state.type,
            userId: state.userId,
            userName: state.userName
          });
          store.commit("setState", { isload: false });
          if (state.enterScene == 1) {
            updateRecharge();
          }
          break;
        // // 客户被拉黑
        case constant.COMMAND_TYPE.CT_ADD_BLACK:
          commit("setState", {
            blackFlag: 1
          });

          break;
        // 客服正在输入
        case constant.COMMAND_TYPE.CT_ENTERING:
          clearTimeout(state.timeObj);
          commit("setState", {
            isEntering: true
          });
          state.timeObj = setTimeout(() => {
            commit("setState", {
              isEntering: false
            });
          }, state.timeout);
          break;
        // 客服取消输入/输入结束
        case constant.COMMAND_TYPE.CT_CANCELENTER:
          clearTimeout(state.timeObj);
          commit("setState", {
            isEntering: false
          });

          break;
        case constant.COMMAND_TYPE.CT_NOTICE_MESSAGE:
          message.noticeInfo.forEach(element => {
            if (element.noticeType == 0) {
              commit("setState", {
                ismarqueue: true
              });
            }
          });
          commit("setState", {
            isShowNotice: true,
            NoticeMessage: message
          });
          break;
      }
    },

    /**
     * 初始化
     */
    async init({ state, commit }, data = {}) {
      data.vipLevel = Number(data.vipLevel);
      data.enterScene = Number(data.enterScene);
      data.cusType = Number(data.cusType);
      // 查询问题类型
      const { data: questionTypes } = await service.queryCusSkill({
        userId: state.userId
      });
      commit("setState", {
        ...data,
        questionTypes
      });
      const initMessages = [
        {
          type: constant.MESSAGE_TYPE.MT_BEFORE_ENTER,
          content: "",
          sendFlag: true,
          chatTime: utils.getTime()
        }
      ];

      const customerId = state.userId;
      initMessages.forEach(message => {
        commit("chat/addMessage", { customerId, message }, { root: true });
      });
    },
    // 关闭窗口
    closeWindow({ state }) {
      MessageBox.confirm(
        "感谢您的支持，真诚的希望下次还能继续为您服务！",
        "确认结束会话？",
        {
          customClass: `tourist-before-login ${state.mainColor} finishChannel`,
          confirmButtonClass: "confirmBtn",
          cancelButtonClass: "cancelBtn",
          confirmButtonText: "结束会话",
          cancelButtonText: "取消",
          type: "warning",
          center: true
        }
      )
        .then(() => {
          this.dispatch("hangupChannel", true);
        })
        .catch(() => {});
    },
    async secondChannel({ commit, state }) {
      let endType = 3;
      // 如果在排队状态
      if (state.isQueue) {
        endType = 4;
      }
      commit("setState", { isload: true });
      await service
        .hangupChannel({
          endType,
          userId: state.userId
        })
        .then(res => {
          if (res && res.code == 200) {
            if (!store.state.isnewChannel) {
              localStorage.clear();
              sessionStorage.clear();
              commit("setState", {
                isConversationEnd: true,
                serverAvatar: constant.testAccount.defaultPhoto,
                serverAlias: "",
                // isConversation: false,
                isShowEvaluatePage: true,
                isQueue: false,
                isload: false
              });
              closeWindows();
            }
          } else {
            if (store.state.isnewChannel) {
              return false;
            } else {
              closeWindows();
            }
          }
        })
        .catch(error => {
          if (
            !store.state.isnewChannel &&
            error.response.data.message != "此客户没有有效会话"
          ) {
            commit("setState", { isload: false });
            Message.error("关闭失败");
          } else if (store.state.isnewChannel) {
            return false;
          } else if (
            !store.state.isnewChannel &&
            error.response.data.message == "此客户没有有效会话"
          ) {
            closeWindows();
          }
        });
    },

    /**
     * 结束会话
     * @param commit
     * @param state
     * @param isBack 如果在app中是否返回上一页
     * @returns {Promise<void>}
     */
    async hangupChannel({ commit, state }, isBack) {
      let endType = 3;
      // 如果在排队状态
      if (state.isQueue) {
        endType = 4;
      }
      if (state.urlData.isEmbedded == 1) {
        await service
          .hangupChannel({
            endType,
            userId: state.userId
          })
          .then(res => {
            if (res && res.code == 200) {
              store.commit("setState", {
                isConversationEnd: true,
                isConversation: false,
                isShowEvaluatePage: true,
                isQueue: false,
                listStatus: false,
                isshowBtn: false,
                serverAlias: ""
              });
            }
          })
          .catch(() => {
            Message.error("关闭失败");
          });
      } else {
        localStorage.removeItem("userId");
        localStorage.removeItem("userName");

        commit("setState", { isload: true });
        await service
          .hangupChannel({
            endType,
            userId: state.userId
          })
          .then(res => {
            if (res && res.code == 200) {
              if (!store.state.isnewChannel) {
                localStorage.clear();
                sessionStorage.clear();
                commit("setState", {
                  isConversationEnd: true,
                  serverAvatar: constant.testAccount.defaultPhoto,
                  serverAlias: "",
                  // isConversation: false,
                  isShowEvaluatePage: true,
                  isQueue: false,
                  isload: false
                });
                closeWindows();
              }
            } else {
              if (store.state.isnewChannel) {
                return false;
              } else {
                closeWindows();
              }
            }
          })
          .catch(error => {
            if (
              !store.state.isnewChannel &&
              error.response.data.message != "此客户没有有效会话"
            ) {
              commit("setState", { isload: false });
              Message.error("关闭失败");
            } else if (store.state.isnewChannel) {
              return false;
            } else if (
              !store.state.isnewChannel &&
              error.response.data.message == "此客户没有有效会话"
            ) {
              closeWindows();
            }
          });
      }

      if (isBack && isApp()) {
        backPage();
      }
    },

    setChannel({ commit }, channelId) {
      commit("setState", { channelId });
    },
    // 信息上传
    async collectCustomerInfo(_, data = {}) {
      const {
        userId,
        userName,
        cusType,
        vipLevel,
        enterScene,
        deviceCode
      } = data;
      // 加访问浏览器和打开客户系统地址
      data.sysTag = getDeviceSystem();
      data.visitSource =
        /mobile/.test(navigator.userAgent) || /Mobile/.test(navigator.userAgent)
          ? 1
          : 2;
      data.accessBrowser = getBrower();
      data.webAddress = window.location.host;
      const params = {
        userId,
        userName,
        cusType,
        vipLevel,
        enterScene,
        deviceCode,
        sysTag: getDeviceSystem(),
        // visitSource: /mobile/.test(navigator.userAgent) ? "移动网络" : "PC网络"
        visitSource:
          /mobile/.test(navigator.userAgent) ||
          /Mobile/.test(navigator.userAgent)
            ? 1
            : 2,
        accessBrowser: getBrower(),
        webAddress: store.state.urlDomain || window.location.host
      };
      const res = await service.collectCustomerInfo(params).catch(() => {
        Message.error("数据返回失败，请刷新页面或确认服务器运行正常");
        return false;
      });

      if (!res) {
        Message.error("数据返回失败，请刷新页面或确认服务器运行正常");
        return false;
      }
      return res;
    },
    async collectDeviceInfo(_, params) {
      return await service.collectDeviceInfo(params);
    },
    async queryDownloadPages(_, params) {
      return await service.queryDownloadPages(params);
    },
    async queryScenes(_, params) {
      return await service.queryScenes(params);
    },
    async checkSeoDomain(_, params) {
      return await service.checkSeoDomain(params);
    },
    //获取评论配置信息
    async getEvaluateConfig({ commit }) {
      const { data } = await service.querySatisfaction();
      commit("setState", { evaluateConfig: data });
    },

    //获取评论结果
    async getEvaluateResult({ commit, state }) {
      const { data } = await service.querySatisfactionContent({
        channelId: state.channelId
      });
      commit("setState", { evaluateResult: data });
    },

    //获取有无历史记录
    async getHistory({ state, commit }) {
      const { data: messages } = await service.getHistoryMessage({
        userId: state.userId
      });
      commit("setState", { hasHistory: messages.length });
    },

    //所有遊戲结果
    async getGameListResult({ commit }) {
      const { data } = await service.getGameList();
      commit("setState", { gameListResult: data });
    },
    //所有支付方式结果
    async getRechargeListResult({ commit }) {
      const { data } = await service.getRechargeList();
      commit("setState", { rechargeListResult: data });
    },

    addQueueTipText({ state, commit, dispatch }) {
      commit("clearAllMessages");
      console.log("排队");
      commit("setState", {
        isQueue: true,
        serverAlias: "",
        serverImage: constant.testAccount.defaultPhoto,
        serverAvatar: constant.testAccount.defaultPhoto,
        serverId: 0,
        isConversation: false,
        isShowNotice: false,
        ismarqueue: false
      });
      let content;
      if (state.customerInfo.leaveType == 1) {
        content = `<div class="text-lineUp">尊敬的用户：您好，现在咨询量较大，我们的客服小妹都在忙碌，需要您耐心等待一下下哦~~~</div><div class="isloading"><div class="f_l"><div class="spinner">正在为您接入<div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div><div class="c_l">客服小妹正在马不停蹄的赶过来，请您稍等</div><a href="/customerMessage">退出排队，去留言</a></div></div>`;
      } else {
        content = `<div class="text-lineUp">尊敬的用户：您好，现在咨询量较大，我们的客服小妹都在忙碌，需要您耐心等待一下下哦~~~</div><div class="isloading"><div class="f_l"><div class="spinner">正在为您接入<div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div><div class="c_l">客服小妹正在马不停蹄的赶过来，请您稍等</div></div></div>`;
      }

      const message = {
        channelId: state.channelId,
        msgId: "QUEUE_NUMBER_TEXT",
        chatTime: utils.getTime(),
        content,
        type: constant.MESSAGE_TYPE.MT_TEXT,
        sendFlag: true,
        isloading: true,
        showBottom: false
      };
      if (state.enterScene == cantants.WakeUpScene.Recharge) {
        updateRecharge();
      }
      dispatch(
        "chat/saveMessage",
        { customerId: state.userId, message, pushStore: true },
        { root: true }
      );
    },
    async setTheme({ state, commit }, theme) {
      let mainColor = state.themeArray.includes(theme);
      if (mainColor) {
        commit("setState", { mainColor: theme });
      }
    },
    closeChannel({ commit }) {
      const o = {
        isConversationEnd: true,
        isConversation: false,
        isShowEvaluatePage: true,
        isQueue: false,
        listStatus: false,
        isshowBtn: false,
        serverAlias: "",
        isShowNotice: false
      };
      commit("setState", o);
    }
  },
  mutations: {
    setState(state, data = {}) {
      Object.keys(data).forEach(key => {
        state[key] = data[key];
      });
    },

    setIsUploadImg(state, flag) {
      state.isUploadImg = flag;
    },
    clearAllMessages(state) {
      state.chat.messageMap = state.chat.messageMap || {};
      state.chat.messageMap[state.userId] = [];
    },
    replaceMessages(state, messages) {
      state.chat.messageMap[state.userId] = messages;
    },
    setIsEntering(state, boolean) {
      state.isEntering = boolean;
    },
    RESTORE_MUTATION: vuexPersist.RESTORE_MUTATION // vuex  数据持久化必要的mutation
  },
  plugins: [vuexPersist.plugin]
});
